import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import { AddIcon } from '@app-velocity/icons';
import { ContextMenu } from '@app-velocity/ui';
import { MessageBus } from '@app-velocity/message-bus';

import { useTeamAccess } from '../../../../hooks';

const NewTeamButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  fontSize: 14,
  svg: {
    width: 14,
    height: 14,
    fill: 'var(--icon-icon-primary-color)',
  },
}));

const StyledMenuItem = styled(ContextMenu.Item)(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
}));

const messageBus = new MessageBus('teams');

export type NewTeamButtonProps = {
  organizationId: string;
};

export const NewTeamButton = ({ organizationId }: NewTeamButtonProps) => {
  const { t } = useI18n();

  const openNewTeamModal = () => {
    messageBus.publish('modal:new-team:open', {
      organisationId: organizationId,
    });
  };

  const { canCreateTeams } = useTeamAccess();

  if (!canCreateTeams) return null;

  return (
    <StyledMenuItem onClick={openNewTeamModal} component="button">
      <NewTeamButtonContainer>
        <AddIcon /> {t('teams:create_new')}
      </NewTeamButtonContainer>
    </StyledMenuItem>
  );
};
